module.exports = __webpack_public_path__ + "img/vendon_logo_0.feeb0994.png";